<template>
  <div class="row">
    <div class="col-4">
      <input
        type="text"
        class="form-control"
        v-model="item.field"
        placeholder="New or existing field name"
      />
    </div>
    <div class="col-1 text-center">
      =
    </div>
    <div class="col-6">
      <input
        type="text"
        class="form-control"
        v-model="item.value"
        placeholder="Value or formula"
      />
    </div>
    <div class="col-1">
      <button type="button" class="btn btn-link text-danger" @click.prevent="$emit('delete')"><i class="fa fa-trash"></i></button>
    </div>

  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: Object,
  },
    computed: {
    item: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
  // watch: {
  //   value(v) {
  //     this.item = v;
  //   },
  //   item: {
  //     deep: true,
  //     handler(v) {
  //       this.$emit("input", v);
  //     },
  //   },
  // },
  // data() {
  //   return {
  //     item: {},
  //   };
  // },
};
</script>

<style scoped>
</style>